import { ResourceItemHtmlProvider } from "./resource-item-html-provider.js";

export class ResourceItemHtmlProviderChefResources extends ResourceItemHtmlProvider {
  constructor(filterServices) {
    super(filterServices);
    this.cssClasses = {

    },
      this.defaultResourceData = [
        {
          imagePath: "/images/default-source/resources/data_sheet-new.svg",
          cta: "Download Now",
          id: "b2b0d12d-c6c0-44c9-83cf-f03965abf50c"
        },
        {
          imagePath: "/images/default-source/resources/webinar-new.svg",
          cta: "Watch the Webinar",
          id: "d743233e-7255-424b-ad23-32b674f698db"
        },
        {
          imagePath: "/images/default-source/resources/whitepaper-new.svg",
          cta: "Download Now",
          id: "32632d8b-f588-4c1d-ac53-e806eaa7b8f4"
        },
        {
          imagePath: "/images/default-source/resources/customer_story-new.svg",
          cta: "View the Customer Story",
          id: "35e120fe-546e-4900-a6c5-324a1ebce270"
        },
        {
          imagePath: null,
          cta: "Watch Video",
          id: "9d8ba3b3-b596-4e59-ac3a-a7df21d642fb"
        },
        {
          imagePath: "/images/default-source/resources/video-new.svg",
          cta: "Watch Video",
          id: "4d293c48-db34-4f40-b68e-df37d3d4b337"
        },
        {
          imagePath: null,
          cta: "Download Now",
          id: "04a0a1e9-8a4a-4570-a981-fdb196bcdf9b"
        },
        {
          imagePath: "/images/default-source/resources/generic-new.svg",
          cta: "Download Now",
          id: "5c0179a1-80e8-4ef2-8f71-8fb79172e700"
        }
      ]
  }

  getItemHtml(item, relatedMedia) {
    let fileData = null;
    let isWebinar = item.resourceCategory[0].Id == "d743233e-7255-424b-ad23-32b674f698db";
    if (item.resourceCategory[0].Id != "35e120fe-546e-4900-a6c5-324a1ebce270") {
      fileData = !item.IsGated && item.File ? item.File : null
    }  
    const { UrlName: resourcePath } = item;
    const CTATextFallback = this.defaultResourceData.find(ct => ct.id === item.resourceCategory[0].Id)?.cta;
    const imagePath = item.ListImage ? item.ListImage.Url : this.defaultResourceData.find(ct => ct.id === item.resourceCategory[0].Id)?.imagePath;
    const imageFallback = '/images/default-source/resources/generic-new.svg';
    const startDateISO = (new Date(item.StartDate)).toISOString();
    const label = `<span class="Label -wa -mb1 -mt1  ${item.IsUpcomming ? "-tint-lightred" : "-tint-lightblue"}">${item.IsUpcomming ? "Upcoming" : "On-Demand"}</span>`;
    const featuredLabel = `${item.IsFeatured ? "<span class='Label -wa -mb1 -mt1 -tint-lightyellow'>Featured</span>": ''}`;
    const summaryParagraph = `<p class="-fs16 -lines-3 -hyphenate">${this.encodeHtml(item.Summary)}</p>`;
    const timeElement =  item.IsUpcomming ? `<time class="h6 -fs12 -c-darkgrey -mb2" datetime="${startDateISO}">${this.getDate(item.StartDate)}</time>`: '';
    const pageUrl = super.getResourceUrl(item.contenttype[0]);
    const resourceUrl = `${pageUrl}/${resourcePath}`;
    const target = fileData != null ?  `target="_blank"` : "";
    const html = `
        <div class="col-3 -xl-half -l-third -m-half -s-full">
            <div class="Card -h-scale">
                <img src="${imagePath || imageFallback}" alt="${item.resourceCategory[0].Title} Thumbnail" />
                <span class='-pa -ml1'>
                ${featuredLabel} ${isWebinar ? label : ''}
                </span>
                <div class="-mt0">
                <p class="-ttu -fs12 -c-darkgrey -ff-title -s-mb1">${item.resourceCategory[0].Title}</p>
                    <h5 class="-mb3">${this.encodeHtml(item.Title)}</h5>
                    ${isWebinar ? timeElement : ''}
                    ${item.Summary ? summaryParagraph : ''}
                    <a href="${fileData == null ? resourceUrl : fileData.Url}" ${target} class="HoverBox -mta -i-next">${this.encodeHtml(item.CTAText) || CTATextFallback}</a>
                </div>
            </div>
        </div>
    `;

    return html;
  } 

  getDate(utcDate){
    let date = new Date(utcDate);
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    return date.toLocaleDateString(undefined, options);
  }
}
